import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ShoppingModeContextType {
  isShoppingMode: boolean;
  setShoppingMode: (mode: boolean) => void;
}

const ShoppingModeContext = createContext<ShoppingModeContextType | undefined>(undefined);

export const useShoppingMode = () => {
  const context = useContext(ShoppingModeContext);
  if (context === undefined) {
    throw new Error('useShoppingMode must be used within a ShoppingModeProvider');
  }
  return context;
};

interface ShoppingModeProviderProps {
  children: ReactNode;
}

export const ShoppingModeProvider: React.FC<ShoppingModeProviderProps> = ({ children }) => {
  const [isShoppingMode, setIsShoppingMode] = useState(false);

  const setShoppingMode = (mode: boolean) => {
    setIsShoppingMode(mode);
  };

  const value = {
    isShoppingMode,
    setShoppingMode,
  };

  return (
    <ShoppingModeContext.Provider value={value}>
      {children}
    </ShoppingModeContext.Provider>
  );
};